<template>
  <el-row>
    <el-tabs v-model="activeName"
             type="card"
             @tab-click="handleClick">
      <el-tab-pane label="未离店"
                   name="cur"></el-tab-pane>
      <el-tab-pane label="已离店"
                   name="his"></el-tab-pane>
    </el-tabs>

    <el-card shadow="none"
             class="form-card mb-15">
      <el-form :inline="true"
               :model="searchForm"
               ref="search_form"
               class="search-form">
        <el-form-item label="姓名:"
                      prop="guest">
          <el-input v-model.trim="searchForm.guest"
                    placeholder="姓名"></el-input>
        </el-form-item>
        <el-form-item label="卡号:"
                      prop="medvalue">
          <el-input v-model.trim="searchForm.medvalue"
                    placeholder="卡号">
            <el-button slot="append"
                       @click="readIC()">读卡</el-button>
          </el-input>
          <span v-if="countDown">请读卡{{timer}}</span>
        </el-form-item>
        <el-form-item label="所属区域:"
                      prop="area_id">
          <el-select v-model="searchForm.area_id"
                     placeholder="请选择所属区域"
                     @change="areaSelChange()">
            <el-option v-for="item in areaList"
                       :key="item.id"
                       :label="item.name"
                       :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="门锁权限:"
                      prop="lock_id">
          <el-select v-model="searchForm.lock_id"
                     placeholder="请选择门锁">
            <el-option v-for="item in lockList"
                       :key="item.id"
                       :label="item.name"
                       :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary"
                     icon="el-icon-search"
                     @click="searchSubmit('search_form')">查询
          </el-button>
          <el-button icon="el-icon-refresh"
                     @click="resetForm('search_form')">重置
          </el-button>
        </el-form-item>
      </el-form>
    </el-card>
    <el-row>
      <el-button v-has="'/hotel/add'"
                 type="primary"
                 @click="openHotelAdd">新增入住</el-button>
    </el-row>
    <el-card shadow="none"
             class="mt-15">
      <el-table max-height="575"
                ref="multipleTable"
                :data="tableData"
                @selection-change="handleSelectionChange">
        <el-table-column type="selection"
                         width="50"> </el-table-column>
        <el-table-column v-for="(item, index) in tableTitle"
                         :fixed="item.fixed"
                         :key="index"
                         :label="item.name"
                         :prop="item.prop"
                         :min-width="item.width"
                         :show-overflow-tooltip="true">
        </el-table-column>
        <el-table-column fixed="right"
                         label="操作"
                         v-if="activeName === 'cur'"
                         width="210">
          <template slot-scope="scope">
            <el-button v-has="'/hotel/del'"
                       plain
                       size="mini"
                       type="danger"
                       @click="handleDel(scope.row)">离店</el-button>
            <el-button v-has="'/hotel/change'"
                       plain
                       size="mini"
                       type="success"
                       @click="handleChange(scope.row)">换房</el-button>
            <el-button v-has="'/hotel/delay'"
                       size="mini"
                       type="primary"
                       @click="handleDelay(scope.row)">续住</el-button>
          </template>
        </el-table-column>
      </el-table>
      <Pagination :total="pagination.total"
                  :pageSize="pagination.perPage"
                  @handleSizeChange="handleSizeChange"
                  @handleCurrent="handleCurrentChange"></Pagination>
    </el-card>
    <hotel-add v-if="showHotelAdd"
               :isShow="showHotelAdd"
               :areaList="areaList"
               @handleClose="closeHotelAdd">
    </hotel-add>
    <hotel-change v-if="showHotelChange"
                  :isShow="showHotelChange"
                  :areaList="areaList"
                  :data="changeData"
                  @handleClose="closecHotelChange"></hotel-change>
    <hotel-delay v-if="showHotelDelay"
                 :isShow="showHotelDelay"
                 :data="delayData"
                 @handleClose="closeHotelDelay"></hotel-delay>
  </el-row>
</template>

<script>
import fetch from '@/common/api'
import mediumApi from '@/common/medium'
//import utils from '@/common/utils'
import HotelAdd from '@/views/humanResources/hotel/HotelAdd'
import HotelChange from '@/views/humanResources/hotel/HotelChange'
import HotelDelay from '@/views/humanResources/hotel/HotelDelay'
import Pagination from '@/components/pagination/Pagination'

export default {
  components: { HotelAdd, HotelChange, HotelDelay, Pagination },
  data() {
    return {
      activeName: 'cur',
      countDown: false,
      timer: 45,
      timeObj: null,
      randomNum: '',
      authId: localStorage.getItem('token'),
      areaList: [],
      lockList: [],
      searchForm: {
        guest: '',
        medvalue: '',
        area_id: '',
        lock_id: ''
      },
      tableTitle: [
        {
          prop: 'medvalue',
          name: '卡号',
          width: '100'
        },
        {
          prop: 'guest',
          name: '姓名',
          width: '100'
        },
        {
          prop: 'lock_name',
          name: '房间',
          width: '100'
        },
        {
          prop: 'in_datetime',
          name: '入住时间',
          width: '120'
        },
        {
          prop: 'exp_datetime',
          name: '离店时间',
          width: '120'
        },
        {
          prop: 'remark',
          name: '备注',
          width: '150'
        }
      ],
      tableData: [],
      // 分页相关
      pagination: {
        total: 0,
        currentPage: 1,
        perPage: 10
      },
      // 选中数据
      multipleSelection: [],
      // 新增入住
      showHotelAdd: false,

      // 换房
      showHotelChange: false,
      changeData: {},

      // 续住
      showHotelDelay: false,
      delayData: {}
    }
  },
  created() {
    this.getList()
    this.getAreaTree()
  },
  methods: {
    //区域选择联动设备筛选
    areaSelChange() {
      this.lockList = []
      this.searchForm.lock_id = ''
      fetch
        .getLockList({ perPage: 0, currentPage: 0, type: 'old', area_id: this.searchForm.area_id })
        .then((data) => {
          data.procData(
            data.res,
            (data) => {
              this.lockList = data.list
            },
            (err) => {
              this.$message.error(err)
            }
          )
        })
    },
    //读取ic卡号
    readIC() {
      // loading倒计时提醒
      this.countDown = true
      this.timeObj = setInterval(() => {
        if (this.timer > 0) {
          this.timer--
        }
        if (this.timer === 0) {
          this.countDown = false
          clearInterval(this.timeObj)
        }
      }, 1000)
      this.randomNum = this.getRandomNum()
      mediumApi
        .getMediumInfo(
          {
            medType: 'ic',
            medTag: this.randomNum
          },
          { timeout: 45000 }
        )
        .then((data) => {
          data.procData(
            data.res,
            (data) => {
              if (data.medType === 'ic' && data.medTag === this.randomNum) {
                this.randomNum = ''
                this.searchForm.medvalue = data.medValue
                this.$message.success('读取成功')
              }
              this.countDown = false
              clearInterval(this.timeObj)
            },
            (err) => {
              this.countDown = false
              clearInterval(this.timeObj)
              this.$message.error(err)
            }
          )
        })
    },
    getRandomNum() {
      let randomNum = new Date().getTime() + ''
      let tmpLen = randomNum.length
      let $chars = 'ABCDEFGHJKMNPQRSTWXYZabcdefhijkmnprstwxyz2345678'
      let maxPos = $chars.length
      for (var i = 0; i < 32 - tmpLen; i++) {
        randomNum += $chars.charAt(Math.floor(Math.random() * maxPos))
      }
      return randomNum
    },
    //选项卡切换
    handleClick() {
      this.getList()
    },

    // 获取列表
    getList() {
      const { perPage, currentPage } = this.pagination
      fetch
        .getHotelList({
          type: this.activeName,
          perPage: perPage,
          currentPage: currentPage,
          ...this.searchForm
        })
        .then((data) => {
          data.procData(
            data.res,
            (data) => {
              this.pagination.total = Number(data.total)
              this.tableData = data.list
            },
            (err) => {
              this.$message.error(err)
            }
          )
        })
    },

    //  格式化名称
    titleFormat(data, prefix) {
      if (data.length === 0) {
        return []
      }
      data.forEach((item) => {
        let tmp = item
        tmp.name = prefix + item.name
        this.tmpArr.push(tmp)
        if (item.children && item.children.length > 0) {
          this.titleFormat(item.children, '• ' + prefix)
        }
      })
      return this.tmpArr
    },
    // 获取数据
    getAreaTree() {
      fetch.getAreaTree({}).then((data) => {
        data.procData(
          data.res,
          (data) => {
            this.tmpArr = []
            this.areaList = this.titleFormat(data.treeData, '• ')
          },
          (err) => {
            this.$message.error(err)
          }
        )
      })
    },
    // 搜索提交
    searchSubmit() {
      this.pagination.perPage = 10
      this.pagination.currentPage = 1
      this.getList()
    },
    resetForm(formName) {
      this.pagination.perPage = 10
      this.pagination.currentPage = 1
      this.$refs[formName].resetFields()
      this.getList()
    },
    // 选择变化
    handleSelectionChange(val) {
      this.multipleSelection = val
    },
    // 分页
    handleSizeChange(val) {
      this.pagination.perPage = val
      this.pagination.currentPage = 1
      this.getList()
    },
    handleCurrentChange(val) {
      this.pagination.currentPage = val
      this.getList()
    },

    // 添加入住
    openHotelAdd() {
      this.showHotelAdd = true
    },
    // 关闭入住
    closeHotelAdd(type) {
      if (type === 'refresh') {
        this.getList()
      }
      this.showHotelAdd = false
    },

    // 更换房间
    handleChange(data) {
      this.showHotelChange = true
      this.changeData = {
        id: data.id,
        lock_id: data.lock_id,
        area_id: data.area_id,
        medvalue: data.medvalue
      }
    },

    // 关闭换房
    closecHotelChange(type) {
      if (type === 'refresh') {
        this.getList()
      }
      this.showHotelChange = false
    },

    // 续住
    handleDelay(data) {
      this.showHotelDelay = true
      this.delayData = {
        id: data.id,
        //这几个都是接口返回的
        exp_date: data.exp_date,
        exp_time: data.exp_time,
        in_date: data.in_date,
        in_time: data.in_time
      }
    },

    // 关闭换房
    closeHotelDelay(type) {
      if (type === 'refresh') {
        this.getList()
      }
      this.showHotelDelay = false
    },

    // 删除入住信息
    handleDel(data) {
      this.$confirm('是否确定离店并删除门卡授权?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          fetch.hotelDel({ id: data.id }).then((data) => {
            data.procData(
              data.res,
              () => {
                this.getList()
                this.$message.success('操作成功')
              },
              (err) => {
                this.$message.error(err)
              }
            )
          })
        })
        .catch(() => {})
    }
  }
}
</script>

<style></style>
